"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * French localization
 */
exports.default = {
    didNotBackUpWallet: "Si vous n'avez pas sauvegardé votre certificat ou si vous avez perdu votre téléphone, contactez le support @RelicSupport.",
};
//# sourceMappingURL=fr.js.map